import { Types } from '@store/types';

const initialState = [];

export const CollectionReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_COLLECTION_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

const roleWiseCollection = [];

export const RoleBasedCollection = (state = roleWiseCollection, action) => {
	switch (action.type) {
		case Types.STORE_ROLE_BASED_COLLECTION_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};
